// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as FilterType from "../../../../../app/entity/FilterType.bs.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as ProgressModal from "../../../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CityVehicleCmp from "../reusable-components/CityVehicleCmp.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SidebarHeaderCmp from "../reusable-components/SidebarHeaderCmp.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as AllocationDashboardUtils from "../../../utils/AllocationDashboardUtils.bs.js";
import * as AllocationDashboardContent from "../../../../../../pricing-dashboard/view/components/vm-mapper/AllocationDashboardContent.bs.js";
import * as CrmControlledReleaseContext from "../../../../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";
import * as CreateZonalOrClusterCampaigns from "./create-campaigns-form/CreateZonalOrClusterCampaigns.bs.js";
import * as AllocationDashboardDataMachine from "../../../../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as AllocationDashboardStateMachine from "../../../AllocationDashboardStateMachine.bs.js";
import * as MandatoryAllocationCampaignsCmp from "./campaign-details/MandatoryAllocationCampaignsCmp.bs.js";
import * as CreateZonalOrClusterCampaignType from "./create-campaigns-form/CreateZonalOrClusterCampaignType.bs.js";
import * as PreviewZonalOrClusterCampaignCmp from "./preview-campaign/PreviewZonalOrClusterCampaignCmp.bs.js";
import * as ZonalOrClusterAllocationCampaignsCmp from "./campaign-details/ZonalOrClusterAllocationCampaignsCmp.bs.js";

function getInitialFormData(vehicle, geo_region, user_name) {
  return {
          vehicle: vehicle,
          geo_region: geo_region,
          created_by: user_name,
          created_on: undefined,
          zones: undefined,
          hasCluster: false,
          clusters: undefined,
          campaignName: undefined,
          startDate: undefined,
          startTime: undefined,
          endDate: undefined,
          endTime: undefined,
          _type: /* Filter */1,
          days: /* [] */0,
          subType: undefined,
          displayFilters: false,
          allocationRadiusManual: undefined,
          allocationRadiusAutomatic: undefined,
          allocationRadiusDelta: undefined,
          thresholdDistance: undefined,
          dryRunRatio: undefined,
          dryRunDelta: undefined,
          maxDryRunManual: undefined,
          maxDryRunAutomatic: undefined,
          maxDryRunDelta: undefined,
          validations: undefined
        };
}

function CreateZonalOrClusterAllocationCampaignCmp(Props) {
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var campaigns_list = Props.campaigns_list;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var dispatch = Props.dispatch;
  var zone_cluster_campaigns_list = Props.zone_cluster_campaigns_list;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var user = React.useContext(CrmControlledReleaseContext.context);
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var showClusterCampaigns = match$2[0];
  var match$3 = React.useState(function () {
        return getInitialFormData(vehicle, geo_region, user.adminBetaAccessData.admin.name);
      });
  var formData = match$3[0];
  var match$4 = React.useState(function () {
        return /* Edit */0;
      });
  var setFormMode = match$4[1];
  var filtered_campaign = Belt_List.keep(campaigns_list.campaigns, (function (campaign) {
          return campaign.campaign_status === /* Active */0;
        }));
  var match$5 = Belt_List.length(filtered_campaign);
  var active_mandatory_campaign = match$5 !== 0 ? (
      match$5 !== 1 ? ErrorUtils$Catalyst.raiseError("CreateMandatoryCampaign.res", "Multiple Mandatory Campaigns found for a given city-vehicle", "Vehicle: " + vehicle.vehicle.vehicle_type + " City: " + geo_region.name) : Belt_List.head(filtered_campaign)
    ) : ErrorUtils$Catalyst.raiseError("CreateMandatoryCampaign.res", "Active Mandatory Campaign not found for given city-vehicle", "Vehicle: " + vehicle.vehicle.vehicle_type + " City: " + geo_region.name);
  React.useEffect((function () {
          if (typeof zones === "number") {
            AllocationDashboardStateMachine.fetchZones(geo_region, dispatch, country);
          }
          if (typeof clusters === "number") {
            AllocationDashboardStateMachine.fetchClusters(geo_region, dispatch, country);
          }
          if (typeof zone_cluster_campaigns_list === "number") {
            AllocationDashboardStateMachine.fetchZonalClusterCampaign(vehicle, geo_region, dispatch, country);
          }
          
        }), []);
  var generateZonalOrClusterCampaignPayload = function (formData) {
    var v = formData.clusters;
    var v$1 = formData.endDate;
    var match = Belt_Option.getExn(formData.subType);
    var tmp;
    switch (match) {
      case /* AllocationRadius */0 :
          tmp = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.allocationRadiusAutomatic);
          break;
      case /* DryRun */1 :
          tmp = undefined;
          break;
      case /* MaxDryRun */2 :
          tmp = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.maxDryRunAutomatic);
          break;
      
    }
    var match$1 = Belt_Option.getExn(formData.subType);
    var tmp$1;
    switch (match$1) {
      case /* AllocationRadius */0 :
          tmp$1 = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.allocationRadiusManual);
          break;
      case /* DryRun */1 :
          tmp$1 = undefined;
          break;
      case /* MaxDryRun */2 :
          tmp$1 = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.maxDryRunManual);
          break;
      
    }
    var match$2 = Belt_Option.getExn(formData.subType);
    var match$3 = Belt_Option.getExn(formData.subType);
    var match$4 = Belt_Option.getExn(formData.subType);
    var tmp$2;
    switch (match$4) {
      case /* AllocationRadius */0 :
          tmp$2 = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.allocationRadiusDelta);
          break;
      case /* DryRun */1 :
          tmp$2 = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.dryRunDelta);
          break;
      case /* MaxDryRun */2 :
          tmp$2 = AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.maxDryRunDelta);
          break;
      
    }
    return {
            geo_region_id: formData.geo_region.id,
            vehicle_id: formData.vehicle.vehicle_id,
            zone_ids: Belt_List.toArray(Belt_Option.getExn(formData.zones)),
            cluster_ids: v !== undefined ? Belt_List.toArray(v) : undefined,
            campaign_name: Belt_Option.getExn(formData.campaignName),
            effective_from: Timestamp$Catalyst.toFloat(Timestamp$Catalyst.startOf(Timestamp$Catalyst.make(Date$Catalyst.toFloat(Belt_Option.getExn(formData.startDate))), /* Day */5)),
            effective_till: v$1 !== undefined ? Timestamp$Catalyst.toFloat(Timestamp$Catalyst.endOf(Timestamp$Catalyst.make(Date$Catalyst.toFloat(Caml_option.valFromOption(v$1))), /* Day */5)) : undefined,
            _type: CreateZonalOrClusterCampaignType.toString(/* Filter */1),
            sub_type: FilterType.toString(Belt_Option.getExn(formData.subType)),
            values: {
              auto: tmp,
              manual: tmp$1,
              threshold: match$2 !== 1 ? undefined : AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertFilterValuesFromKilometersToMeters(formData.thresholdDistance),
              ratio: match$3 !== 1 ? undefined : Belt_Option.getExn(formData.dryRunRatio),
              radius_delta: tmp$2
            },
            days_of_week: Belt_List.toArray(List.map((function (x) {
                        return x.toLocaleUpperCase();
                      }), formData.days)),
            day_start_hour: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertTimestampToHours(formData.startTime),
            day_start_min: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertTimestampToMinutes(formData.startTime),
            day_end_hour: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertTimestampToHours(formData.endTime),
            day_end_min: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.convertTimestampToMinutes(formData.endTime),
            validations: Belt_Option.map(formData.validations, (function (validationsList) {
                    return {
                            validations: Belt_Array.map(validationsList, (function (validationItem) {
                                    return {
                                            validation_type: validationItem.validation_type,
                                            segment_names: validationItem.segment_names
                                          };
                                  }))
                          };
                  }))
          };
  };
  var onSubmitZonalClusterCampaigns = function (param) {
    return Curry._1(dispatch, {
                TAG: /* OpenModal */10,
                modal: {
                  isOpen: true,
                  onCancel: (function (param) {
                      return Curry._1(dispatch, /* CloseModal */3);
                    }),
                  onSubmit: (function (param) {
                      Curry._1(dispatch, /* CloseModal */3);
                      var payload = generateZonalOrClusterCampaignPayload(formData);
                      Curry._1(setRequestStatus, (function (param) {
                              return {
                                      TAG: /* Loading */0,
                                      _0: undefined
                                    };
                            }));
                      return AllocationDashboardDataMachine.createZonalOrClusterCampaign(payload, (function (param) {
                                    Curry._1(dispatch, {
                                          TAG: /* UpdateSidebarState */6,
                                          opened_sidebar: undefined
                                        });
                                    Curry._1(setRequestStatus, (function (param) {
                                            return {
                                                    TAG: /* Live */1,
                                                    _0: undefined
                                                  };
                                          }));
                                    var v = payload.cluster_ids;
                                    if (v !== undefined) {
                                      var match = v.length;
                                      if (match !== 0) {
                                        Curry._1(dispatch, {
                                              TAG: /* OpenSnackbar */7,
                                              snackbar_message: {
                                                TAG: /* Success */0,
                                                _0: AllocationDashboardContent.cluster_campaign_sent_for_approval
                                              }
                                            });
                                      } else {
                                        Curry._1(dispatch, {
                                              TAG: /* OpenSnackbar */7,
                                              snackbar_message: {
                                                TAG: /* Success */0,
                                                _0: AllocationDashboardContent.zonal_campaign_sent_for_approval
                                              }
                                            });
                                      }
                                    }
                                    return Curry._1(dispatch, {
                                                TAG: /* SetZoneClusterCamapigns */13,
                                                zoneClusterCampaigns: /* Init */0
                                              });
                                  }), (function (error) {
                                    Curry._1(dispatch, {
                                          TAG: /* OpenSnackbar */7,
                                          snackbar_message: {
                                            TAG: /* Error */1,
                                            _0: ErrorUtils$Catalyst.resolveError(error)
                                          }
                                        });
                                    return Curry._1(setRequestStatus, (function (param) {
                                                  return {
                                                          TAG: /* Error */2,
                                                          _0: error
                                                        };
                                                }));
                                  }));
                    }),
                  title: "Create Campaign",
                  confirm_button_title: "Yes, Proceed",
                  cancel_button_title: "No, Cancel",
                  modal_body: showClusterCampaigns ? AllocationDashboardContent.create_cluster_campaign_modal_box : AllocationDashboardContent.create_zonal_campaign_modal_box
                }
              });
  };
  var tmp;
  if (typeof zones === "number" || !(zones.TAG === /* Live */1 && !(typeof clusters === "number" || clusters.TAG !== /* Live */1))) {
    tmp = React.createElement(React.Fragment, undefined);
  } else {
    var clusters$1 = clusters._0;
    var zones$1 = zones._0;
    var tmp$1;
    tmp$1 = typeof zone_cluster_campaigns_list === "number" || zone_cluster_campaigns_list.TAG !== /* Live */1 ? null : React.createElement(ZonalOrClusterAllocationCampaignsCmp.make, {
            showClusterCampaigns: showClusterCampaigns,
            zone_cluster_campaigns_list: zone_cluster_campaigns_list._0,
            zones: zones$1,
            clusters: clusters$1,
            active_mandatory_campaign: active_mandatory_campaign
          });
    tmp = React.createElement("div", {
          className: "ald-campaign-details-sidebar-container"
        }, React.createElement(SidebarHeaderCmp.make, {
              preview: true,
              campaign_name: undefined,
              discard_warning_required: true,
              dispatch: dispatch
            }), React.createElement("div", {
              className: "existing-campaigns-and-form-data"
            }, React.createElement("div", {
                  className: "all-existing-campaigns"
                }, React.createElement(MandatoryAllocationCampaignsCmp.make, {
                      filtered_campaings: campaigns_list.campaigns
                    }), tmp$1), React.createElement("div", {
                  className: "ald-sidebar-panel"
                }, React.createElement(CityVehicleCmp.make, {
                      vehicle_name: vehicle.vehicle.vehicle_type,
                      geo_region: geo_region.name
                    }), match$4[0] ? React.createElement("div", {
                        className: "campaign-details-body"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp.make, {
                            active_mandatory_campaign: active_mandatory_campaign,
                            form_data: formData,
                            setFormMode: setFormMode,
                            onSubmit: onSubmitZonalClusterCampaigns,
                            zones: zones$1,
                            clusters: clusters$1
                          })) : React.createElement("div", {
                        className: "create-campaign-body"
                      }, React.createElement("div", undefined, React.createElement(CreateZonalOrClusterCampaigns.make, {
                                state: formData,
                                zones: zones$1,
                                clusters: clusters$1,
                                updateFormData: match$3[1],
                                setFormMode: setFormMode,
                                dispatch: dispatch,
                                setShowClusterCampaigns: match$2[1],
                                showClusterCampaigns: showClusterCampaigns
                              }))))));
  }
  var tmp$2;
  var tmp$3 = match$1[0];
  tmp$2 = typeof tmp$3 === "number" || tmp$3.TAG !== /* Loading */0 ? null : React.createElement(ProgressModal.make, {
          isOpen: true
        });
  return React.createElement(React.Fragment, undefined, tmp, React.createElement(React.Fragment, undefined, tmp$2));
}

var make = CreateZonalOrClusterAllocationCampaignCmp;

export {
  getInitialFormData ,
  make ,
  
}
/* react Not a pure module */
